import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Document, Payment } from '../../../shared/sdk';
import { PaymentService } from '../../../payments/payment.service';
import { ClientService } from '../../../clients/client.service';
import { DocumentService } from '../../document.service';
import { ReminderSendComponent } from '../../../clients/reminder/reminder-send.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailDocumentComponent } from '../../email-document/email-document.component';
import { PaymentAddComponent } from '../../../payments/payment-add/payment-add.component';

@Component({
  selector: 'app-active-document-dropdown-menu',
  templateUrl: './active-document-dropdown-menu.component.html',
  styleUrls: ['./active-document-dropdown-menu.component.css'],
})
export class ActiveDocumentDropdownMenuComponent implements OnInit {
  @Input() currentLang: string;
  @Input() document: Document;
  @Input() incoming: boolean;
  @Input() isPast: boolean;
  @Output() addPayment = new EventEmitter();
  @Output() cancel = new EventEmitter();
  @Output() delete = new EventEmitter();

  constructor(
    private clientService: ClientService,
    private documentService: DocumentService,
    private paymentService: PaymentService,
    private modalService: NgbModal,
  ) {}

  ngOnInit(): void {}

  onCancel(): void {
    this.cancel.emit(this.document);
  }

  onDelete(): void {
    this.delete.emit(this.document);
  }

  onDownloadPdf(): void {
    this.documentService
      .downloadFile({
        document: this.document,
        type: 'pdf',
        ext: 'pdf',
        lang: this.currentLang,
      })
      .subscribe();
  }

  onOpenEmailModal(): void {
    const modalRef = this.modalService.open(EmailDocumentComponent);
    modalRef.componentInstance.document = this.document;
    modalRef.result.then(
      (obs) =>
        obs.subscribe(
          () => {},
          () => {},
        ),
      () => {},
    );
  }

  onOpenPaymentModal(): void {
    const due = this.documentService.getTotalOwed(this.document);
    const payment = {
      amount: due,
      documentId: this.document.id,
      currencyId: this.document.currencyId,
    };

    const modalRef = this.modalService.open(PaymentAddComponent, {
      size: 'sm',
    });
    modalRef.componentInstance.payment = payment;

    modalRef.result
      .then((newPayment: Payment) => {
        if (newPayment) {
          this.addPayment.emit(newPayment);
        }
      })
      .catch(() => {});
  }

  onOpenPdf(lang?: string): void {
    this.documentService.openFile(this.document.id, 'pdf', lang).subscribe();
  }

  onOpenReminderModal(): void {
    const modalRef = this.modalService.open(ReminderSendComponent);
    modalRef.componentInstance.clientId = this.document.clientId;
    this.clientService.sendReminder(modalRef);
  }
}
